import React from "react";
import { useParams, useLocation } from "react-router-dom";
import TripCard from "../../components/trip-cards/TripCard";
import './SavedTrip.css'
import EditTripNav from "../../components/navbar/edittrip-nav/EditTripNav";

function SavedTrip() {
  const { id } = useParams();
  const location = useLocation();
  const dataToFormat = location.state;
  const data = {
    "TRIP_NAME": dataToFormat.name,
    "DESTINATION": dataToFormat.destination,
    "START_DATE": dataToFormat.startDate,
    "END_DATE": dataToFormat.endDate,
  };
  return (
    <>
      <div className="saved-trip">
        <EditTripNav />
        <TripCard trip={data} />
      </div>
    </>
  );
}

export default SavedTrip;
